import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import LocalStorage from '../helper/LocalStorage';
import { useUserContext } from '../context/useUserContext';
import LoaderComponent from '../Components/Generic/LoaderComponent';
import { authBridgeLogin } from '../api/authBridge';


const ProtectedRoute = ({ children }) => {

    const { fetchCurrentUser, userRef } = useUserContext();

    const location = useLocation();
    const navigate = useNavigate();

    const authToken = LocalStorage.getAuthenticationToken();

    const [bridgeChecking, setBridgeChecking] = useState(false);
    const [bridgeDone, setBridgeDone] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const bridgeToken = params.get("bridge");

        if (!bridgeToken) {
            setBridgeDone(true);
            return;
        }

        LocalStorage.removeBridgeOptedOut();
        setBridgeChecking(true);

        authBridgeLogin(bridgeToken).then((result) => {
            if (result?.token && result?.refresh_token) {
                LocalStorage.setAuthenthicationToken(result.token);
                LocalStorage.setRefreshToken(result.refresh_token);
                LocalStorage.setSSOFlag(true);

                params.delete("bridge");
                const newSearch = params.toString();
                window.history.replaceState(
                    null,
                    "",
                    location.pathname + (newSearch ? `?${newSearch}` : "")
                );

                fetchCurrentUser(
                    () => {
                        setBridgeChecking(false);
                        setBridgeDone(true);
                    },
                    () => {
                        setBridgeChecking(false);
                        setBridgeDone(true);
                        navigate("/login");
                    }
                );
            } else {
                setBridgeChecking(false);
                setBridgeDone(true);
                navigate("/login");
            }
        });
    }, []);

    useEffect(() => {
        if (!bridgeDone) return;

        const currentToken = LocalStorage.getAuthenticationToken();
        if (currentToken !== null) {
            fetchCurrentUser(
                function (response) {
                    // Only navigate if we actually have a target path to restore
                    if (location.state?.backTo) {
                        navigate({
                            pathname: location.state.backTo,
                            search: location.search,
                        });
                    }
                },
                function (error) {
                    navigate(
                        "/login",
                        {
                            search: location.search,
                            state: { backTo: `${location.pathname}` }
                        }
                    )
                }
            );
        }
    }, [bridgeDone]);

    if (bridgeChecking || !bridgeDone) {
        return <LoaderComponent loading={true} />;
    }

    const currentToken = LocalStorage.getAuthenticationToken();

    if (currentToken == null) {
        return (
            <Navigate
                to={"/login"}
                state={{
                    backTo: `${location.pathname}`,
                    search: `${location.search}`
                }}
            />
        );
    }

    if (currentToken) {
        return (
            <>
                {userRef.current ? children : <LoaderComponent loading={true} />}
            </>
        );
    }
}

export default ProtectedRoute
